import { SEARCH_AGGREGATES } from '@/utils/constants'
import { IParamsByUrl } from '~types/search'

const removeFilter = (
  params: IParamsByUrl,
  filter: string,
  type: string
): IParamsByUrl => {
  const newParams = { ...params }

  switch (type) {
    case SEARCH_AGGREGATES.categories:
      newParams.categories = params.categories.filter((item) => item !== filter)
      break
    case SEARCH_AGGREGATES.brands:
      newParams.brands = params.brands.filter((item) => item !== filter)
      break
    case SEARCH_AGGREGATES.tags:
      newParams.tags = params.tags.filter((item) => item !== filter)
      break
    case SEARCH_AGGREGATES.priceRanges:
      newParams.priceRanges = { gte: 0, lte: 0 }
      break
    case SEARCH_AGGREGATES.availablePromotions:
      newParams.availablePromotions = params.availablePromotions.filter(
        (item) => item !== filter
      )
      break
    case SEARCH_AGGREGATES.operationalModels:
      newParams.operationalModels = params.operationalModels.filter(
        (item) => item !== filter
      )
      break
    default:
      break
  }

  return newParams
}

export default removeFilter
